const SEARCH_RESULT_STATE = {
  LOADING: "loading",
  CLOSED: "closed",
  EMPTY: "empty",
  HAS_RESULTS: "hasResults",
} as const;

export { SEARCH_RESULT_STATE };
